import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("proalp_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-5" data-testid="admin-login-page">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-sm border border-white/10 bg-[#0A0A0A] p-8"
      >
        <img src="/logo.png" alt="PROALP22" className="h-36 w-auto" />
        <p className="mt-1 flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-500">
          <Lock size={12} /> Admin
        </p>
        <input
          data-testid="admin-email"
          type="email"
          required
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="mt-8 w-full border-b border-white/20 bg-transparent py-3 text-sm outline-none transition-colors focus:border-[#FF5A00]"
        />
        <input
          data-testid="admin-password"
          type="password"
          required
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="mt-4 w-full border-b border-white/20 bg-transparent py-3 text-sm outline-none transition-colors focus:border-[#FF5A00]"
        />
        {error && (
          <p data-testid="admin-login-error" className="mt-4 text-xs text-red-400">{error}</p>
        )}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-8 flex w-full items-center justify-center gap-2 bg-[#FF5A00] py-3.5 text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#E04F00] disabled:opacity-60"
        >
          {loading && <Loader2 size={14} className="animate-spin" />}
          Sign in
        </button>
        <button
          type="button"
          data-testid="admin-back-home"
          onClick={() => navigate("/")}
          className="mt-4 w-full text-center text-xs uppercase tracking-widest text-neutral-500 transition-colors hover:text-white"
        >
          ← Back to site
        </button>
      </form>
    </div>
  );
}
